import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Box, Button, Dialog, FormControl, TextField, useMediaQuery} from "@mui/material";
import * as React from "react";
import {MobileDatePicker} from "@mui/x-date-pickers";
import Divider from "@mui/material/Divider";

const SignedRecipentTransferMakePaid = ({ openByStatus, handleCloseConfirmation, handleMakeItFinalized, reason, setReason, finalizedAt, setFinalizedAt }) => {
    const sizeMatch = useMediaQuery('@media (min-width:600px)')

    return (
        <Dialog
            fullScreen={!sizeMatch}
            sx={{ '& .MuiDialog-paper': { width: '100%', maxWidth: '600px', maxHeight: 435 }, padding: 2 }}

            maxWidth="xs"
            open={openByStatus.finalized ?? !!openByStatus.finalized }
            onClick={event => event.stopPropagation()}
        >
            <DialogTitle>{"Baixa Manual"}</DialogTitle>
            <DialogContent>
                <Box>
                {"Deseja realmente finalizar o repasse ?"}
                </Box>
                <FormControl sx={{marginTop: 2}}  >
                    <MobileDatePicker
                        label="Finalizado em"
                        value={finalizedAt}
                        onChange={(timestamp) => {
                            setFinalizedAt(timestamp)
                        }}
                        slotProps={{
                            field: {clearable: true, onClear: () => setCleared(true)},
                            textField: {
                                size: "small"
                            }
                        }}
                    />

                </FormControl>
                <TextField
                    id="reason-for-finishing"
                    label="Motivo"
                    fullWidth
                    margin="normal"
                    value={reason}
                    onChange={e => setReason(e.target.value)}
                />
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between' }}>
                <Button autoFocus onClick={handleCloseConfirmation}>{"Cancelar"}</Button>
                <Button variant={"contained"} onClick={handleMakeItFinalized}>{"Confirmar"}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default SignedRecipentTransferMakePaid